export enum Theme {
  URGENCY = 'pwa-theme--urgency',
  SUCCESS = 'pwa-theme--success',
  SUCCESS_MEDIUM = 'pwa-theme--success uitk-type-medium',
  LINK = 'pwa-theme--link',
  NONE = ''
}

export enum ThemeName {
  URGENT = 'URGENCY',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  LINK = 'LINK',
  NONE = 'NONE'
}
